import { useEffect, useState } from 'react';

import { MotionEndStyled } from './styled';

import clsx from 'clsx';
import { get, ref } from 'firebase/database';
import MotionCard from 'src/components/MotionCard';
import database from 'src/libraries/firebase';
import { kindToName } from 'src/libraries/health';

interface MotionEndProps {
  className?: string;
}
const tempHistory = [
  {
    kind: 1,
    set: 1,
    success: 5,
    fail: 0,
  },
  {
    kind: 1,
    set: 2,
    success: 3,
    fail: 2,
  },
];

const MotionEnd = ({ className }: MotionEndProps) => {
  const [historys, setHistorys] = useState([]);

  useEffect(() => {
    (async () => {
      const robotSettingRef = ref(database, 'health_robot/history');
      const snapshot = await get(robotSettingRef);
      const robotHealthHistorys: any = Object.values(snapshot.val());

      const localHistory = JSON.parse(localStorage.getItem('history') || '[]');
      localHistory.push(robotHealthHistorys);
      localStorage.setItem('history', JSON.stringify(localHistory));

      setHistorys(robotHealthHistorys);
    })();
  }, []);

  return (
    <MotionEndStyled className={clsx('MotionEnd', className)}>
      {tempHistory.map((history: any, index) => (
        <MotionCard
          key={index}
          title={`${kindToName(history.kind)} ${history.set} 세트`}
          success={history.success}
          fail={history.fail}
        />
      ))}
    </MotionEndStyled>
  );
};

export default MotionEnd;
